var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "faq-search u-12/12@xs u-8/12@md u-push-2/12@md u-relative@xs u-absolute@md",
      attrs: { id: "faq-search" }
    },
    [
      _c(
        "div",
        { staticClass: "faq-search__input-wrapper" },
        [
          _c("VueTagsInput", {
            staticClass: "search-tags",
            attrs: {
              placeholder: _vm.placeholder,
              tags: _vm.tags,
              "max-tags": 10,
              "add-on-key": [13, 32, ","],
              "avoid-adding-duplicates": false
            },
            on: { "tags-changed": _vm.updateTags },
            model: {
              value: _vm.tag,
              callback: function($$v) {
                _vm.tag = $$v
              },
              expression: "tag"
            }
          }),
          _vm._v(" "),
          _c(
            "ElButton",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.keywords.length,
                  expression: "keywords.length"
                }
              ],
              staticClass: "clear-button",
              attrs: { type: "text" },
              on: { click: _vm.clear }
            },
            [_c("i", { staticClass: "fa fa-times-circle" })]
          ),
          _vm._v(" "),
          _c(
            "ElButton",
            { staticClass: "search-button", on: { click: _vm.search } },
            [_c("i", { staticClass: "fa fa-search u-color--quaternary" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "faq-search__results",
          class: { "show-results": _vm.showResults }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { "margin-top": "60px" }
            },
            [
              _vm.results.length > 0
                ? _c(
                    "ElCollapse",
                    { attrs: { accordion: "" } },
                    _vm._l(_vm.results, function(result, index) {
                      return _c(
                        "ElCollapseItem",
                        {
                          key: index,
                          attrs: { title: result.title, name: index }
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(result.answer) }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "municipality-wrapper" },
                            _vm._l(result.municipalities, function(item, idx) {
                              return _c(
                                "span",
                                { key: idx, staticClass: "municipality" },
                                [
                                  _c("a", { attrs: { href: item.url } }, [
                                    _vm._v(_vm._s(item.title))
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    }),
                    1
                  )
                : _c("p", [
                    _vm._v("\n        Geen resultaten gevonden\n      ")
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c("FeedbackForm", { attrs: { payload: { keywords: _vm.keywords } } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }